import React from 'react';
import { Portal as HeadlessPortal } from '@headlessui/react';
export const Portal = ({ children }) => (React.createElement(HeadlessPortal, null, children));
//# sourceMappingURL=Portal.js.map